import { render, staticRenderFns } from "./OrderDetailsFooter.vue?vue&type=template&id=8929145e&"
import script from "./OrderDetailsFooter.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports